import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const SeguroAuto = lazy(() => import('../pages/seguro-auto/page'));
const SeguroResidencial = lazy(() => import('../pages/seguro-residencial/page'));
const SeguroVida = lazy(() => import('../pages/seguro-vida/page'));
const SeguroCargas = lazy(() => import('../pages/seguro-cargas/page'));
const SeguroCasco = lazy(() => import('../pages/seguro-casco/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/seguro-auto',
    element: <SeguroAuto />,
  },
  {
    path: '/seguro-residencial',
    element: <SeguroResidencial />,
  },
  {
    path: '/seguro-vida',
    element: <SeguroVida />,
  },
  {
    path: '/seguro-cargas',
    element: <SeguroCargas />,
  },
  {
    path: '/seguro-casco',
    element: <SeguroCasco />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;